import qs from 'qs'

const resource = 'partnerUsers';

export default ($axios) => ({
	getPartnerUsers(params) {
		return $axios.get(`/${resource}`,
		{
			params,
			paramsSerializer: params => {
				return qs.stringify(params, {
					arrayFormat: 'indices',
					encode: false
				});
			} 
		});
	}
})